import apiClient from "services/apiClient";

async function editBehavior(id: any, data: any) {
  const url = `/admin/behaviors/${id}`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editBehavior;
